import { Stack } from '@mui/material'
import { EquipmentOperationalStatus } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel } from '@tom-ui/ui'

interface Props {
  isInOperation?: boolean
  operationalStatus?: EquipmentOperationalStatus
  isOwned?: boolean
  isInactive?: boolean
  alignment?: 'start' | 'end'
}

export const EquipmentStatusChip = ({
  isInOperation,
  operationalStatus,
  alignment,
  isInactive,
  isOwned,
}: Props) => {
  const { t } = useTranslate()

  return (
    <Stack alignItems={alignment ?? 'start'} direction='row' gap={theme => theme.customSpacing.xs}>
      {!isOwned && <ColoredLabel label={t('external', 'external')} color='info' />}
      {isInOperation && <ColoredLabel label={t('inOperation', 'In operation')} color='busy' />}
      {isInactive ? (
        <ColoredLabel label={t('unavailable', 'Unavailable')} color='secondary' />
      ) : (
        <>
          {(!operationalStatus || operationalStatus === EquipmentOperationalStatus.Available) &&
            isInOperation === false && (
              <ColoredLabel label={t('available', 'Available')} color='success' />
            )}

          {!isInOperation &&
            operationalStatus &&
            operationalStatus === EquipmentOperationalStatus.Unavailable && (
              <ColoredLabel label={t('unavailable', 'Unavailable')} color='warning' />
            )}
        </>
      )}
    </Stack>
  )
}
